import React, { useState, useRef, useEffect } from "react";
import "./LoginStyle.scss";
import { useNavigate,useLocation } from "react-router-dom";
import { fetchResendOtp, fetchVerifyOTPNewUSer } from "../../Store/newUser/NewUserAction";
import { InputText } from "primereact/inputtext";
import { useDispatch } from "react-redux";
import { Button } from 'primereact/button';


const VerifyOtpForNewUser = ({
  otpInputTestId
 }) => {
  const inputRefs = useRef(
    Array(6)
      .fill(null)
      .map(() => React.createRef())
  );
  const [inputValue, setInputValue] = useState(Array(6).fill(""));
  const [otp, setOtp] = useState("");
  const [fieldsAreFilleds, setFieldsAreFilleds] = useState(false);
  const [fieldsRequiredErrors, setFieldsRequiredErrors] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation(); // Use useLocation hook to access location object
  const contact = location.state.contact;
  const navigate = useNavigate();
  const OtpNewUserVerification = () => {
    dispatch(fetchVerifyOTPNewUSer(contact, otp,navigate));
  }
const resendOTPs = () => {
  dispatch(fetchResendOtp(contact));
}
  const handleInputChanges = (index, value, ee) => {
        if (ee.keyCode === 8 && index > 0) {
          // Move to the previous input field for backspace
          inputRefs.current[index - 1].current.focus();
        } else if (index < inputRefs.current.length - 1 && value !== "") {
          // Move to the next input field if available and a value is entered
          inputRefs.current[index + 1].current.focus();
        }

        const newValue = [...inputValue];
        newValue[index] = value;
        setInputValue(newValue);

        // Check if all fields are filled
        const allFilled = newValue.every(val => val !== "");
        setFieldsAreFilleds(allFilled);
        setFieldsRequiredErrors(!allFilled);
      };

  useEffect(() => {
    const handleEnteredNumbers = (enteredNumbers) => {
      setOtp(enteredNumbers);
    };

    const enteredNumbers = inputValue.join("");
    handleEnteredNumbers(enteredNumbers);
  }, [inputValue]);


  let firstFiveDigits = contact.substring(0, 8);
  const renderInputFields = () => (
    <>
      {inputRefs.current.map((ref, index) => (
        <div className="flex" key={ref}>
          <InputText
            keyfilter="int"
            maxLength="1"
            className={`otp-input text-xl border-round-md border-1 ${
              inputValue[index] && "active"
            }`}
            value={inputValue[index]}
            onChange={(e) => handleInputChanges(index, e.target.value, e)}
            onKeyDown={(e) => handleInputChanges(index, "", e)}
            ref={ref}
            data-testid={`${otpInputTestId}-${index}`}
          />

        </div>
      ))}
    </>
  );

  return (
    <div className='mb-2'>
      <div className="text-blue-900 font-semibold text-4xl ">
        OTP Verification{" "}
      </div>
      <div className="text-500 text-sm w-26rem ">
        Enter OTP received on {firstFiveDigits}***** |
        Not Received?
        <span className="text-blue-900 font-semibold" onClick={resendOTPs}> Resend OTP</span>
      </div>
      <div className="mt-3 flex flex-row flex-wrap gap-3 w-30rem mr-4">
        {renderInputFields()}
      </div>
      {fieldsRequiredErrors && !fieldsAreFilleds && <div className="text-red-500">Fields are required.</div>}
      <div>
      <Button className="login-btn mt-4 w-30rem" onClick={OtpNewUserVerification} data-testid="verify-otp-button">
        Verify OTP
      </Button>
      </div>
    </div>
  );
};

export default VerifyOtpForNewUser;
